<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
      <el-breadcrumb-item>设置商品税率</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="请输入商品名称" v-model="queryInfo.query" clearable @clear="getGoodsList">
            <el-button slot="append" icon="el-icon-search" @click="getGoodsList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="goAddpage">批量设置</el-button>
        </el-col>
      </el-row>

      <!-- table表格区域 -->
      <el-table :data="goodslist" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed> </el-table-column>

        <el-table-column type="index"></el-table-column>
        <el-table-column label="商品名称" prop="title" width="180px"></el-table-column>
        <el-table-column label="商品类型" prop="type" width="80px"></el-table-column>
        <el-table-column label="商品编号" prop="number" width="100px"></el-table-column>
        <el-table-column label="封面" width="120px" align="center">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.fengmian" fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="商品价格" align="center" prop="price" width="95px"></el-table-column>
        <el-table-column label="税率" align="center" prop="taxRate" width="95px"></el-table-column>
        <el-table-column label="操作" width="130px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="editById(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>

      <!-- 修改商品的对话框 -->
      <el-dialog title="修改商品税率" :visible.sync="editGoodVisible" width="50%" @close="editGoodDialogClosed">
        <el-form :model="editGoodForm" :rules="editGoodFormRule" ref="editGoodFormRef" label-width="100px">
          <el-form-item label="税率" prop="taxRate">
            <el-input v-model="editGoodForm.taxRate"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editGoodVisible = false">取 消</el-button>
          <el-button type="primary" @click="changeGoodClick">确定修改</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 查询参数对象
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10
      },

      editGoodForm: {
        taxRate: null
      },

      editGoodFormRule: {
        taxRate: [
          { required: true, message: '请输入税率', trigger: 'blur' }
        ]
      },
      // 商品列表
      goodslist: [],
      multipleSelection: [],
      // 总数据条数
      total: 0,
      selectId: 0,
      editGoodVisible: false,
      isOne: false,
    }
  },

  created () {
    this.getGoodsList()
  },

  methods: {

    //批量设置税率
    goAddpage () {
      if (this.multipleSelection.length == 0) {
        return this.$message.error('请勾选相关商品')
      }
      this.editGoodVisible = true
      this.isOne = false
    },

    //确认
    changeGoodClick(){
      if(this.isOne){
        this.sureToeditById()
      }else{
        this.moreSureToeditById()
      }
    },

    // 多选选择的项
    handleSelectionChange (val) {
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      this.multipleSelection = list
      console.log(list)
       
    },

    // 根据分页获取对应的商品列表
    async getGoodsList () {
      const { data: res } = await this.$http.post('admin/good/list', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取商品列表失败！')
      }
      this.$message.success('获取商品列表成功！')
      console.log(res.result)
      this.goodslist = res.result.list
      this.total = res.result.count
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getGoodsList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getGoodsList()
    },

    //设置单个税率
    async sureToeditById (id) {
      this.$refs.editGoodFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/good/setGoodInvoice', {
          id: this.selectId,
          taxRate: this.editGoodForm.taxRate,
        })
        if (res.code !== 200) {
          return this.$message.error('设置失败！')
        }
        this.$message.success('设置成功！')
        this.getGoodsList()
        this.editGoodVisible = false
      })
    },

    //批量设置税率
    async moreSureToeditById (id) {
      this.$refs.editGoodFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/good/setGoodMoreInvoice',
          {
            data: this.multipleSelection,
            taxRate: this.editGoodForm.taxRate,
          })
        if (res.code !== 200) {
          return this.$message.error('设置失败！')
        }
        this.$message.success('设置成功！')
        this.getGoodsList()
        this.editGoodVisible = false
      })
    },

    // 编辑
    editById (id) {
       this.isOne = true
      this.selectId = id;
      this.editGoodVisible = true
      console.log(id);
    },

    editGoodDialogClosed(){
      this.editGoodVisible = false
      this.selectId =null
      this.editGoodForm.taxRate = null
    }
  }
}
</script>

<style lang="less" scoped>
.tip {
  font-size: 13px;
  color: #cccccc;
}
</style>
